<div
    class="buttons-container"
    [style.--toggle-button-background-color]="colorPalette()[3].solid"
    [style.--toggle-button-button-color]="colorPalette()[1].solid"
    [style.--toggle-button-text-color]="colorPalette()[12].solid"
    [style.--toggle-button-border-color]="colorPalette()[6].solid"
>
    @for (option of options(); track option.code) {
        <button
            type="button"
            [trackClick]="option.trackClick"
            [class.selected]="option.code === currentValue()"
            [advizeoTooltip]="option.hint"
            [attr.disabled]="option.disabled ? true : undefined"
            (click)="optionSelected(option.code)"
        >
            @if (option.icon) {
                <ui-icon size="small" [name]="option.icon" [rawColor]="colorPalette()[12].solid" />
            }
            <span>{{ option.label }}</span>
        </button>
    }
</div>
